import 'shared/styles';
import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import HeadTags from './head';
import LandingPage from './landingPage';
import Storefront from './storefront';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

class Home extends React.Component {
  render() {
    const showLandingPage = _.isEmpty(this.props.address);

    return (
      <Fragment>
        <HeadTags />
        <TransitionGroup>
          {showLandingPage ? (
            <CSSTransition
              key="home-landing-page"
              classNames="homepage"
              timeout={{ enter: 500, exit: 300 }}
            >
              <LandingPage />
            </CSSTransition>
          ) : (
            <CSSTransition
              key="home"
              classNames="homepage"
              timeout={{ enter: 500, exit: 300 }}
            >
              <Storefront />
            </CSSTransition>
          )}
        </TransitionGroup>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    address: state.address
  };
}

export default connect(mapStateToProps, {})(Home);



// WEBPACK FOOTER //
// ./shared/components/home/index.js